const rootActionPath = 'core/adblock';

export const ADBLOCK_IS_INSTALLED_CONFIRM = `${rootActionPath}/IS_INSTALLED_CONFIRM`;
export const ADBLOCK_IS_INSTALLED_SEND_ANALYTICS = `${rootActionPath}/IS_INSTALLED_SEND_ANALYTICS`;
